var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSmokeDetector = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 243",
  d: "M437.02 74.98A256 256 0 0074.98 437.02 256 256 0 00437.02 74.98zm0 0",
  fill: "#e7f0ef"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 244",
  d: "M437.02 74.98A254.334 254.334 0 00256 0v512A256 256 0 00437.02 74.98zm0 0",
  fill: "#c5e1e6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 245",
  d: "M152.09 227.969a15.017 15.017 0 01-13.855-20.746 126.655 126.655 0 0168.984-68.988 15 15 0 0111.48 27.719 96.826 96.826 0 00-52.746 52.75 15.009 15.009 0 01-13.863 9.265zm0 0",
  fill: "#988fcc"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 246",
  d: "M92.715 203.371a15.006 15.006 0 01-13.852-20.746A190.479 190.479 0 01182.629 78.859a15 15 0 0111.48 27.715 160.712 160.712 0 00-87.531 87.531 15.009 15.009 0 01-13.863 9.266zm0 0",
  fill: "#988fcc"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 35",
  fill: "#6e61b7"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 247",
  d: "M359.91 227.969a15 15 0 01-13.863-9.266 96.813 96.813 0 00-52.746-52.75 15 15 0 0111.48-27.719 126.63 126.63 0 0168.984 68.988 15.014 15.014 0 01-13.855 20.746zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 248",
  d: "M419.285 203.371a14.99 14.99 0 01-13.859-9.266 160.688 160.688 0 00-87.535-87.527 15 15 0 0111.48-27.719 190.5 190.5 0 01103.77 103.77 15.005 15.005 0 01-13.855 20.742zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 249",
  d: "M299.043 374.91a15 15 0 01-5.746-28.863 96.794 96.794 0 0052.746-52.747 15 15 0 0127.719 11.477 126.63 126.63 0 01-68.984 68.988 14.973 14.973 0 01-5.735 1.145zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 250",
  d: "M323.641 434.285a15 15 0 01-5.746-28.863 160.693 160.693 0 0087.527-87.531 15 15 0 1127.715 11.484 190.479 190.479 0 01-103.766 103.766 14.94 14.94 0 01-5.73 1.144zm0 0"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 251",
  d: "M212.953 374.91a14.891 14.891 0 01-5.734-1.148 126.636 126.636 0 01-68.984-68.984 15 15 0 1127.715-11.48 96.845 96.845 0 0052.75 52.75 15 15 0 01-5.746 28.863zm0 0",
  fill: "#988fcc"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 252",
  d: "M188.359 434.285a14.94 14.94 0 01-5.73-1.145 190.5 190.5 0 01-103.77-103.77 15 15 0 0127.715-11.48 160.712 160.712 0 0087.531 87.531 15 15 0 01-5.746 28.863zm0 0",
  fill: "#988fcc"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 253",
  d: "M256 192.8a63.2 63.2 0 1063.2 63.2 63.271 63.271 0 00-63.2-63.2zm0 0",
  fill: "#ed6c7b"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 254",
  d: "M256 192.8v126.4a63.2 63.2 0 000-126.4zm0 0",
  fill: "#d65b72"
})));
export default SvgSmokeDetector;